import { toast } from "react-toastify";
import { BiPlus } from "react-icons/bi";
import { FC, useEffect, useState } from "react";
import { AiOutlineEdit } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { getAPI } from "../../../../services/CRUDServices";
import { addEditUrls } from "../../../../services/api.enums";
import { setOrder } from "../../../../redux/OrderData/OrderData";
import SelectCustomerForm from "../../../ConsignmentManageOperation/view/AddOrderForm/SelectCustomerForm/SelectCustomerForm";
import SelectAddressForm from "../../../ConsignmentManageOperation/view/AddOrderForm/SelectReturnAddressForm/SelectAddressForm";
import EditAddressForm from "pages/ConsignmentManageOperation/view/AddOrderForm/EditReturnAddressForm/EditAddressForm";

const OrderDataTopNav:FC<{returnAddress?:boolean}> = ({returnAddress}) => {
  const [OpenCustomer, setOpenCustomer] = useState(false);
  const [OpenReturn, setOpenReturn] = useState(false);
  const [isOpenEditReturn, setIsOpenEditReturn] = useState(false);

  const { orderData, consignments } = useSelector((state: any) => state.Order);

  const dispatch = useDispatch();

  useEffect(() => {
    getAPI(
      `${addEditUrls.hub}/${
        JSON.parse(localStorage.getItem("currenthub") as any).id
      }`
    ).then((res) => {
      dispatch(
        setOrder({
          fromCountryDevisionId: res?.data?.payload?.selectCity?.id,
          fromCountryDevisionName: res?.data?.payload?.selectCity?.text,
          pickupHubId: JSON.parse(localStorage.getItem("currenthub") as any).id,
          // pickupAddressId: JSON.parse(localStorage.getItem("currenthub") as any).id,
        })
      );
    });
  }, [dispatch, OpenCustomer]);

  const AddOrderElements = ({ title, action, value }: any) => (
    <div className="border rounded-2xl p-3 w-full">
      <div className="flex-between-center mb-3">
        <p className="font-medium">{title}</p>
        {action}
      </div>
      <p className="text-darkBorder h-4 text-xs text-ellipsis overflow-hidden">
        {" "}
        {value}
      </p>
    </div>
  );

  const handleOpenReturnAddress = () => {
    if (orderData.senderCustomerId) {
      orderData?.returnAddressId || orderData?.returnHubId
        ? setIsOpenEditReturn(true)
        : setOpenReturn(true);
    } else toast.error("ابتدا اطلاعات فرستنده را وارد نمایید");
  };
  const sendFrom = JSON.parse(localStorage.getItem("currenthub") as any).label;
  const getReturnText = ()=>{

  }
  return (
    <>
      <div className="flex-between-center max-w-6xl Max-md:flex-col gap-4">
        <AddOrderElements
          title="فرستنده"
          value={orderData.senderCustomerName}
          action={
            <span onClick={() => setOpenCustomer(true)}>
              {orderData.senderCustomerId ? (
                consignments.length === 0 && (
                  <AiOutlineEdit
                    size={20}
                    className="text-darkBorder cursor-pointer"
                  />
                )
              ) : (
                <BiPlus size={23} className="text-darkBorder cursor-pointer" />
              )}
            </span>
          }
        />
        <AddOrderElements
          title={` ارسال از ${orderData.fromCountryDevisionName ?? ""}`}
          value={sendFrom}
        />
        <AddOrderElements
          title={`انتخاب آدرس `}
          value={` برگشت به ${
            returnAddress?sendFrom:((orderData.returnAddressName ?? "") || (orderData.returnHubName ?? ""))
          } `}
          action={
            <span onClick={handleOpenReturnAddress}>
              {orderData.returnAddressId || orderData?.returnHubId ? (
                consignments.length === 0 && (
                  <AiOutlineEdit
                    size={20}
                    className="text-darkBorder cursor-pointer"
                  />
                )
              ) : (
                <BiPlus size={23} className="text-darkBorder cursor-pointer" />
              )}
            </span>
          }
        />
      </div>
      <SelectCustomerForm open={OpenCustomer} setOpen={setOpenCustomer} />
      <SelectAddressForm open={OpenReturn} setOpen={setOpenReturn} />
      <EditAddressForm open={isOpenEditReturn} setOpen={setIsOpenEditReturn} />
    </>
  );
};

export default OrderDataTopNav;
